import { useApi } from "@/.shared/.api/integration";
import { useIntl } from "@/.shared/services/i18n";
import { useModalService } from "@/.shared/services/modal-service";
import OperacionesResumen from "@/components/operaciones-energia/OperacionesEnergiaResumen.vue";
import OperacionesAguaResumen from "@/components/operaciones-agua/OperacionesAguaResumen.vue";
import BorradorOperacionDetailPanel from "@/components/borradores-operacion/BorradorOperacionDetailPanel.vue";
import { ApiError } from "@/.shared/services/http";
import { toastError } from "@/.shared/services/notification-service";
import { GENERAL_NOT_FOUND } from "@/.shared/errors/codes";

function padSecuencial(value: number): string {
  return value.toString().padStart(10, "0");
}

function buildOperacionTitle(intl: ReturnType<typeof useIntl>, codigo: number): string {
  return `${intl.i18n.t("operaciones.detalle.titulo")} ${padSecuencial(codigo)}`;
}

export async function mostrarDetalleBorrador(idBorrador: string){
  const api = useApi();
  const modal = useModalService();
  const intl = useIntl();

  const title = String(intl.i18n.t("borradores-operacion.detalle.titulo"));
  try{
    const response = await api.callStandardApi("getBorradorOperacionDetail", { showLoading: true }, idBorrador);
    await modal.showModal(BorradorOperacionDetailPanel, { model: response }, { title, width: 800, height: 700 });
  }
  catch (e: any) {
    if (e instanceof ApiError && e.details?.errorList.length === 1 && [GENERAL_NOT_FOUND].includes(e.details.errorList[0].Code)) {
      toastError(intl.i18n.t(`shared.errors.api.Operaciones.DraftNotFound`));
    } else {
      throw e;
    }
  }
}

export async function mostrarDetalleOperacion(idOperacion: string, tipo: 'ENERGIA' | 'AGUA') {
  const api = useApi();
  const modal = useModalService();
  const intl = useIntl();

  switch (tipo) {
    case 'ENERGIA':
    {
      const response = await api.callStandardApi("getOperacionEnergiaDetail", { showLoading: true }, idOperacion);
      const title = buildOperacionTitle(intl, response.CodigoSecuencial);
      const estructuraDocumental = await api.callStandardApi("getEstructuraDocumentalOperacionEnergia", { showLoading: false }, idOperacion);
      await modal.showModal(OperacionesResumen, { data: response, estructuraDocumental }, { title });
    }
      break;
    case 'AGUA':
    {
      const response = await api.callStandardApi("getOperacionAguaDetail", { showLoading: true }, idOperacion);
      const title = buildOperacionTitle(intl, response.CodigoSecuencial);
      const estructuraDocumental = await api.callStandardApi("getEstructuraDocumentalEmpresaServicios",{ showLoading: false }, response.IdEmpresaServicios, response.Titular.TipoPersona);
      await modal.showModal(OperacionesAguaResumen, { data: response, estructuraDocumental }, { title });
    }
      break;
  }
}